export default __webpack_public_path__ + "static/media/nbc-sports.1e23707e.svg";